import { render, staticRenderFns } from "./PromocodeInput.vue?vue&type=template&id=3f5ffe5d&scoped=true&"
import script from "./PromocodeInput.vue?vue&type=script&lang=js&"
export * from "./PromocodeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ffe5d",
  null
  
)

export default component.exports